<template>
<div class="container mt-3 px-0" v-if="showContent">
    <ul class="nav nav-tabs">
        <li class="nav-item" v-if="content.files && content.files.length > 0">
            <div
                class="nch--custom-tab"
                href="#"
                :class="{active: currentTab === 'OptionsSupport'}"
                @click="setTab('OptionsSupport')"
            >
                <i class="mdi mdi-paperclip"/>
                <span>{{$t('common.support_material')}}</span>
            </div>
        </li>
        <li class="nav-item" v-if="content.forum">
            <div
                class="nch--custom-tab"
                href="#"
                :class="{active: currentTab === 'OptionsForum'}"
                @click="setTab('OptionsForum')"
            >
                <i class="mdi mdi-forum"></i>
                <span>{{$t('common.forum')}}</span>
            </div>
        </li>
        <li class="nav-item" v-if="content.lesson_translation.description">
            <div
                class="nch--custom-tab"
                href="#"
                :class="{active: currentTab === 'OptionsDescription'}"
                @click="setTab('OptionsDescription')"
            >
                <i class="mdi mdi-information"></i>
                <span>{{$t('common.description')}}</span>
            </div>
        </li>
    </ul>
    <options-forum
        v-if="currentTab === 'OptionsForum'"
        :content="content"
    />
    <options-description
        v-if="currentTab === 'OptionsDescription'"
        :content="content"
    />
    <options-support
        v-if="currentTab === 'OptionsSupport'"
        :content="content"
    />
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import OptionsSupport from './Options/OptionsSupportMaterial';
import OptionsForum from './Options/OptionsForum';
import OptionsDescription from './Options/OptionsDescription';

export default {
    name: 'TabOptions',

    components: {
        OptionsSupport,
        OptionsForum,
        OptionsDescription,
    },

    data() {
        return {
            currentTab: null,
            showContent: false,
        };
    },

    methods: {
        setTab(option) {
            this.currentTab = option;
        },
        checkContent() {
            if (!this.content || !this.content.files) return;
            if (this.content.lesson_translation.description !== null) {
                this.currentTab = 'OptionsDescription';
                this.showContent = true;
                return;
            } else if (this.content.files.length) {
                this.currentTab = 'OptionsSupport';
                this.showContent = true;
                return;
            } else if (this.content.forum) {
                this.currentTab = 'OptionsForum';
                this.showContent = true;
                return;
            }
            this.showContent = false;
        },
    },

    computed: mapGetters({ content: 'CLASS_CONTENT' }),

    mounted() {
        this.checkContent();
    },
};
</script>
